import axios from 'axios';
import URLS from '../../util/urls';

const state = {
  listaContratosRenovar: []
}

const mutations = {
  atualizarListaContratosRenovar(state, payload) {
    state.listaContratosRenovar = payload;
  },

  limparLista(state) {
    state.listaContratosRenovar = [];
  }
}

const actions = {
  recuperarContratosRenovar(context, payload) {
    return axios.post(URLS.DASHBOARD_RECUPERAR_CONTRATOS_RENOVAR, payload)
    .then((response) => {
      switch (response.data.status) {
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == 'SUCESSO') {
              return context.dispatch('recuperarContratosRenovar', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          context.commit('atualizarListaContratosRenovar', response.data.lista);
      }
    }).catch(error => {
      throw error;
    });
  }
}


export default {
  state,
  mutations,
  actions
}